import { ITableSetting } from "../../../../Table/BasicTable";
import {
  IconWrapper,
  ImageWrapper,
} from "../../../ui-components/pageLayout/TableSettingsComponents";
import noImage from "../../../../../../resources/missing-img.png";
import { MdModeEditOutline } from "react-icons/md";
import { CMSAsset } from "@client/models/CMS/cmsAsset";
import { format, isValid, parseISO } from "date-fns";
import { SOURCE_TYPE_OPTIONS, VOD_TYPE_OPTIONS } from "./vodListParams";
import PlayabilityBadge from "../../../components/AssetLibrary/PlayabilityBadge";

const formatDate = (value?: string) => {
  if (!value) return "";
  const date = parseISO(value);
  return isValid(date) ? format(date, "yyyy-MM-dd HH:mm") : value;
};

const labelFor = (
  options: { value: string; label: string }[],
  value?: string
) => options.find((o) => o.value === value)?.label ?? value ?? "";

export const AssetsPageTableSettings: ITableSetting<CMSAsset>[] = [
  {
    id: "image-id",
    align: "left",
    name: "",
    path: "gg",
    content: (data: CMSAsset) => (
      <ImageWrapper>
        <div
          className="image"
          style={{
            backgroundImage: `url(${data.images?.[0]?.source || noImage})`,
          }}
        />
      </ImageWrapper>
    ),
  },
  {
    id: "name-id",
    align: "left",
    name: "NAME",
    path: "NAME",
    content: (data: CMSAsset) => (
      <div>
        <div>{data.getDisplayName()}</div>
        <PlayabilityBadge playability={data.playability} />
      </div>
    ),
  },
  {
    id: "id-id",
    align: "left",
    name: "ID",
    path: "ID",
    content: (data: CMSAsset) => <div>{data.getUniqueId()}</div>,
  },
  {
    id: "type-id",
    align: "left",
    name: "TYPE",
    path: "TYPE",
    content: (data: CMSAsset) => (
      <div>{labelFor(VOD_TYPE_OPTIONS, data.type)}</div>
    ),
  },
  {
    id: "source-id",
    align: "left",
    name: "SOURCE",
    path: "SOURCE",
    content: (data: CMSAsset) => (
      <div>{labelFor(SOURCE_TYPE_OPTIONS, data.sourceType)}</div>
    ),
  },
  {
    id: "created-id",
    align: "left",
    name: "CREATED",
    path: "CREATED",
    content: (data: CMSAsset) => <div>{formatDate(data.createdDate)}</div>,
  },
  {
    id: "changed-id",
    align: "left",
    name: "CHANGED",
    path: "CHANGED",
    content: (data: CMSAsset) => <div>{formatDate(data.changedDate)}</div>,
  },
  {
    id: "edit-id",
    align: "right",
    name: "",
    path: "gh",
    content: () => (
      <IconWrapper>
        <MdModeEditOutline />
      </IconWrapper>
    ),
  },
];
